import PrecisionHotspot from './PrecisionHotspot';

export default PrecisionHotspot;
